import { FC } from "react";
import StepNavigationStep from "components/StepNavigation/composition/StepNavigationStep";
import Button from "components/Inputs/Button";
import { Trans, useTranslation } from "react-i18next";
import { searchMarketAction } from "pages/Home/core/home.helpers";
import {
  MyliPlatformId,
  IConfigurationState,
  IAPIObjective,
} from "redux/configuration/configuration.interface";
import { useSelector } from "react-redux";
import { IModalChild } from "utils/types/modalChild";
import { useMarketActionCTA } from "utils/hooks/useMarketActionCTA/useMarketActionCTA";
import { getMobileOperatingSystem } from "utils";

interface IProps extends IModalChild {}

const isIos = getMobileOperatingSystem() === "iOS";

const ModalConfigStepDownloadApp: FC<IProps> = ({ hideModal }) => {
  const { t } = useTranslation("modals", { keyPrefix: "downloadApp" });
  const { configuration } = useSelector((state: IConfigurationState) => state);

  const marketAction = searchMarketAction(
    isIos
      ? MyliPlatformId.DOWNLOAD_APP_IOS
      : MyliPlatformId.DOWNLOAD_APP_ANDROID,
    configuration?.w
  );

  const handleCTAClick = useMarketActionCTA(
    hideModal,
    marketAction?.u,
    IAPIObjective.DOWNLOAD_APP
  );

  return (
    <StepNavigationStep className="modal__content" step={1}>
      <div className="modal__img p-0">
        <img
          src="/static/images/modals/download-app.png"
          alt="downloadApp icon"
          style={{ borderRadius: "100px" }}
        />
      </div>

      <h2 className="modal__title">
        <Trans
          ns="modals"
          i18nKey="downloadApp.title"
          components={[<span className="c-primary"></span>]}
        />
      </h2>
      <p className="mb-3">
        <Trans
          ns="modals"
          i18nKey="downloadApp.subtitle"
          values={{ restaurant: configuration?.name }}
          components={[<span className="c-primary fw-700"></span>]}
        />
      </p>

      <Button
        text={t(isIos ? "CTA.ios" : "CTA.android")}
        onClick={handleCTAClick}
        appearance="primary"
        className="modal__btn"
      />
    </StepNavigationStep>
  );
};

export default ModalConfigStepDownloadApp;
